import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppQuery } from "../../../api/fetchClient";
import { QUERY_KEYS } from "../../../api/queryKeys";
import { GET_FEEDBACK } from "../../../api/url";
import Loader from "../../../components/common/Loader";

import { arrowForward, Close, ProfileImage } from "../../../assets/image";
import moment from "moment";

const FeedBack = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);

  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [showFeedback, setShowFeedback] = useState(false);
  const modalRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowFeedback(false);
      }
    };

    if (showFeedback) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showFeedback]);

  const {
    data: userData,
    isLoading,
    isError,
    isRefetching,
  } = useAppQuery({
    queryKey: [QUERY_KEYS.FEEDBACK, page],
    url: `${GET_FEEDBACK}?page=${page}`,
  });

  const handleUserProfile = (user) => {

    navigate("/admin/user/userDetails", { state: { userId: user.userId } });
  };



  if (isLoading || isRefetching) return <Loader />;
  if (isError) return <div className="p-4 text-red-600">Failed to load users.</div>;

  const { pagination, data } = userData?.results ?? {};
  const { currentPage, totalPages } = pagination ?? {};



  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-primary">Feedback</h1>
        <p className="text-sm text-gray-600">View user feedback and manage actions</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {data?.map((user) => {
          return (
            <div
              key={user._id}
              onClick={() => {
                if (user) {
                  setShowFeedback(true);
                  setSelectedFeedback(user);
                }
              }}
              className="bg-white shadow-sm p-4 rounded-lg hover:shadow-md transition"
            >
              <div onClick={() => handleUserProfile(user)} className="flex items-center gap-3 cursor-pointer">
                <img
                  src={user?.userProfileImage ? user.userProfileImage : ProfileImage}
                  alt="User"
                  className="h-10 w-10 rounded-full object-cover"
                />

                <div>
                  <h4 className="text-base font-semibold text-dark">{user?.username || "-"}</h4>
                  <p className="text-sm text-gray-500">{user?.email || "-"}</p>
                </div>
              </div>

              <div className="mt-4 truncate text-sm text-gray-700 cursor-pointer">
                <strong>Feedback:</strong> {user?.feedback || "-"}
              </div>

              <div className="mt-2 text-sm">
                <strong>Submitted Time:</strong> {moment(user?.createdAt).fromNow()}
              </div>
            </div>
          );
        })}
      </div>

      {totalPages > 1 && (
        <div className="mt-6 flex justify-center items-center space-x-2">
          {Array.from({ length: totalPages }, (_, index) =>
            index < 2 || index > totalPages - 3 || Math.abs(page - (index + 1)) <= 1 ? (
              <button
                key={index}
                onClick={() => setPage(index + 1)}
                className={`px-4 py-2 rounded-md border text-sm font-medium ${
                  currentPage === index + 1
                    ? "bg-primary text-white border-primary"
                    : "bg-white text-gray-700 hover:bg-gray-100 border-gray-300"
                }`}
              >
                {index + 1}
              </button>
            ) : null
          )}

          <button
            onClick={() => setPage((old) => old + 1)}
            disabled={page === totalPages}
            className={`flex items-center px-3 py-2 rounded-md border text-sm font-medium ${
              page === totalPages
                ? "bg-gray-200 text-light cursor-not-allowed"
                : "bg-white text-gray-700 hover:bg-gray-100 border-gray-300"
            }`}
          >
            <img src={arrowForward} alt="Next" />
          </button>
        </div>
      )}

      {showFeedback && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div ref={modalRef} className="bg-white p-6 rounded-xl shadow-lg max-w-3xl w-full">
            <div className=" mb-4 flex justify-between">
              <h2 className="text-lg font-semibold">User Feedback</h2>
              <img
                onClick={() => {
                  setShowFeedback(false);
                }}
                src={Close}
                alt=""
                className="w-5 h-5"
              />
            </div>
            <div
              onClick={() => handleUserProfile(selectedFeedback)}
              className="flex items-center gap-3 mb-3 cursor-pointer"
            >
              <img
                src={selectedFeedback?.userProfileImage}
                alt="User"
                className="h-10 w-10 rounded-full object-cover"
              />
              <div>
                <h4 className="text-base font-semibold text-dark">{selectedFeedback?.username || "-"}</h4>
                <p className="text-sm text-gray-500">{selectedFeedback?.email || "-"}</p>
              </div>
            </div>

            <div className="mb-3 text-sm">
              <strong>Submitted Time:</strong> {moment(selectedFeedback?.createdAt).fromNow()}
            </div>
            <div className="overflow-y-auto max-h-[calc(100vh-220px)]">
              <p className="text-gray-800">{selectedFeedback?.feedback}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FeedBack;
